function devtricker_addCodeHeader(block) {
    const wrapper = document.createElement("div");
    wrapper.classList.add("code-wrapper");


    const header = document.createElement("div");
    header.classList.add("code-header");
    const language = Array.from(block.classList).find(className => className.startsWith("language-")).replace("language-", "");
    const headerLanguage = document.createElement("span");

    headerLanguage.textContent = language;
    header.appendChild(headerLanguage);

    const copyButton = document.createElement("button");
    copyButton.classList.add("btn", "d-inline-flex", "align-items-center");

    copyButton.addEventListener("click", function (event) {

        event.preventDefault();
        event.stopPropagation();

        const clickedItem = event.target;
        const originalHTML = "<span class='icon icon-clipboard'></span>Copy";

        clickedItem.innerHTML = "<span class='icon icon-check'></span>Copied!";

        const codeBlock = clickedItem.closest(".code-wrapper").querySelector("code");

        if (codeBlock) {
            navigator.clipboard.writeText(codeBlock.innerText).then(() => {
                console.log("Text copied to clipboard");

                setTimeout(() => {
                    clickedItem.innerHTML = originalHTML;
                }, 3000);
            }).catch(err => {
                console.error("Failed to copy text: ", err);
            });
        }


    });
    copyButton.innerHTML = "<span class='icon icon-clipboard'></span>Copy";


    header.appendChild(copyButton);

    wrapper.appendChild(header);
    block.parentNode.insertBefore(wrapper, block);
    wrapper.appendChild(block.parentNode.removeChild(block));
}

function devtricker_styleNotSupportedLanguage(block) {
    if (!block.getAttribute('data-highlighted')) {
        block.classList.add('hljs');
    }
}

function devtricker_initializeCodeHighlights() {
    document.querySelectorAll('pre code:not(.highlight-initialized)').forEach(function (block) {
        hljs.highlightElement(block);
        devtricker_addCodeHeader(block);
        devtricker_styleNotSupportedLanguage(block);
        block.classList.add('highlight-initialized');
    });
}


function devtricker_removeCodeHighlights(block) {
    const wrapper = block.closest('.code-wrapper');
    if (wrapper) {
        wrapper.parentNode.insertBefore(block, wrapper);
        block.classList.remove('highlight-initialized');
        wrapper.remove();
    }
}